(() => {
  const root = document.querySelector("[data-product-root]");
  if (!root) return;

  const jsonEl = document.querySelector("[data-product-json]");
  if (!jsonEl) return;

  let product;
  try {
    product = JSON.parse(jsonEl.textContent);
  } catch {
    return;
  }

  const variants = product.variants || [];
  const track = root.querySelector("[data-gallery-track]");
  const gallery = root.querySelector("[data-gallery]");
  const thumbsWrap = root.querySelector("[data-gallery-thumbs]");
  const colorLabel = root.querySelector("[data-color-label]");
  const sizeErr = root.querySelector("[data-size-err]");
  const sizeBtns = [...root.querySelectorAll("[data-size]")];
  const addBtns = [...root.querySelectorAll("[data-add]")];
  const swatches = [...root.querySelectorAll("[data-color]")];
  const guide = document.querySelector("[data-guide]");
  const priceNow = root.querySelector(".lp-price .price-now");
  const stickyNow = root.querySelector(".sticky-price .price-now");

  const decode = (value) => {
    if (!value) return "";
    const el = document.createElement("textarea");
    el.innerHTML = value;
    return el.value.trim();
  };

  const money = (cents) => {
    try {
      return new Intl.NumberFormat("fr-FR", {
        style: "currency",
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || "EUR",
      }).format(cents / 100);
    } catch {
      return `${(cents / 100).toFixed(2).replace(".", ",")} €`;
    }
  };

  const slides = [...root.querySelectorAll(".gallery-slide")];
  const slidesByColor = new Map();
  for (const slide of slides) {
    const key = decode(slide.dataset.color || slide.dataset.alt || "");
    if (!slidesByColor.has(key)) slidesByColor.set(key, []);
    slidesByColor.get(key).push(slide);
  }

  const colorKeys = swatches.map((btn) => decode(btn.dataset.color));
  let color =
    decode(swatches.find((b) => b.classList.contains("is-on"))?.dataset.color) ||
    colorKeys[0] ||
    variants[0]?.option1 ||
    "";
  let size = null;

  function variantsForColor(colorName) {
    return variants.filter((v) => v.option1 === colorName);
  }

  function availableSizes() {
    return new Set(
      variantsForColor(color)
        .filter((v) => v.available !== false)
        .map((v) => String(v.option2)),
    );
  }

  function currentVariant() {
    return variants.find((v) => v.option1 === color && String(v.option2) === String(size));
  }

  function firstAvailableVariantForColor(colorName) {
    const list = variantsForColor(colorName);
    return list.find((v) => v.available !== false) || list[0] || null;
  }

  function slidesForColor(colorName) {
    const exact = slidesByColor.get(colorName);
    if (exact && exact.length) return exact;
    // never mix colors — empty rather than wrong images
    return [];
  }

  function renderGallery() {
    const vis = slidesForColor(color);
    slides.forEach((slide) => {
      const on = vis.includes(slide);
      slide.classList.toggle("is-visible", on);
      if (on) slide.removeAttribute("hidden");
      else slide.setAttribute("hidden", "");
    });
    if (gallery) gallery.classList.add("is-ready");

    if (track) track.scrollLeft = 0;

    if (!thumbsWrap) return;
    if (!vis.length) {
      thumbsWrap.innerHTML = "";
      thumbsWrap.hidden = true;
      return;
    }

    thumbsWrap.innerHTML = vis
      .map((slide, i) => {
        const img = slide.querySelector("img");
        const src = img?.currentSrc || img?.src || "";
        return `<button type="button" class="thumb${i === 0 ? " is-on" : ""}" data-thumb="${i}" aria-label="Photo ${i + 1}"><img src="${src}" alt=""></button>`;
      })
      .join("");
    thumbsWrap.hidden = vis.length < 2;

    thumbsWrap.querySelectorAll("[data-thumb]").forEach((btn) => {
      btn.addEventListener("click", () => {
        const idx = Number(btn.dataset.thumb);
        const target = vis[idx];
        if (!target || !track) return;
        track.scrollTo({ left: target.offsetLeft - track.offsetLeft, behavior: "smooth" });
        thumbsWrap.querySelectorAll(".thumb").forEach((t) => t.classList.toggle("is-on", t === btn));
      });
    });
  }

  function renderSizes() {
    const avail = availableSizes();
    sizeBtns.forEach((btn) => {
      const ok = avail.size === 0 ? true : avail.has(String(btn.dataset.size));
      btn.classList.toggle("is-off", !ok);
      btn.disabled = !ok;
      if (!ok && String(size) === String(btn.dataset.size)) {
        size = null;
        btn.classList.remove("is-on");
      }
    });
  }

  function renderPrice() {
    const v = currentVariant() || firstAvailableVariantForColor(color);
    if (!v || typeof v.price !== "number") return;
    const label = money(v.price);
    if (priceNow) priceNow.textContent = label;
    if (stickyNow) stickyNow.textContent = label;
  }

  function setStickyLabel() {
    addBtns.forEach((btn) => {
      btn.textContent = size ? "Ajouter au panier" : "Choisis ta taille";
    });
  }

  function selectColor(nextColor, btn) {
    color = decode(nextColor);
    swatches.forEach((b) => {
      const on = b === btn || decode(b.dataset.color) === color;
      b.classList.toggle("is-on", on);
      b.setAttribute("aria-pressed", on ? "true" : "false");
    });
    if (colorLabel) colorLabel.textContent = color;
    size = null;
    sizeBtns.forEach((s) => s.classList.remove("is-on", "is-err"));
    if (sizeErr) sizeErr.hidden = true;
    renderGallery();
    renderSizes();
    renderPrice();
    setStickyLabel();
  }

  swatches.forEach((btn) => {
    btn.addEventListener("click", () => selectColor(btn.dataset.color, btn));
  });

  sizeBtns.forEach((btn) => {
    btn.addEventListener("click", () => {
      if (btn.disabled) return;
      size = String(btn.dataset.size);
      sizeBtns.forEach((s) => s.classList.toggle("is-on", s === btn));
      if (sizeErr) sizeErr.hidden = true;
      sizeBtns.forEach((s) => s.classList.remove("is-err"));
      renderPrice();
      setStickyLabel();
    });
  });

  addBtns.forEach((btn) => {
    btn.addEventListener("click", async () => {
      if (!size) {
        if (sizeErr) sizeErr.hidden = false;
        sizeBtns.forEach((s) => s.classList.add("is-err"));
        root.querySelector("[data-size-block]")?.scrollIntoView({ behavior: "smooth", block: "center" });
        return;
      }
      const variant = currentVariant();
      if (!variant) {
        alert("Cette combinaison couleur / taille n’est pas disponible.");
        return;
      }
      btn.disabled = true;
      const prev = btn.textContent;
      btn.textContent = "Un instant…";
      try {
        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: variant.id, quantity: 1 }),
        });
        if (!res.ok) throw new Error("cart");
        window.location.href = "/checkout";
      } catch {
        btn.disabled = false;
        btn.textContent = prev;
        setStickyLabel();
        alert("Impossible d’ajouter au panier. Réessaie.");
      }
    });
  });

  root.querySelector("[data-open-guide]")?.addEventListener("click", () => {
    if (guide) guide.hidden = false;
  });
  document.querySelectorAll("[data-close-guide]").forEach((btn) => {
    btn.addEventListener("click", () => {
      if (guide) guide.hidden = true;
    });
  });

  // Init from ?variant= if present
  const params = new URLSearchParams(window.location.search);
  const variantId = Number(params.get("variant"));
  if (variantId) {
    const fromUrl = variants.find((v) => v.id === variantId);
    if (fromUrl) {
      const btn = swatches.find((b) => decode(b.dataset.color) === fromUrl.option1);
      if (btn) selectColor(fromUrl.option1, btn);
      const sizeBtn = sizeBtns.find((b) => String(b.dataset.size) === String(fromUrl.option2));
      if (sizeBtn && !sizeBtn.disabled) sizeBtn.click();
    } else {
      renderGallery();
      renderSizes();
      renderPrice();
      setStickyLabel();
    }
  } else {
    renderGallery();
    renderSizes();
    renderPrice();
    setStickyLabel();
  }
})();
